exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Icon{display:inline-block;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-rules-2!./node_modules/postcss-loader/lib??ref--3-rules-3!./node_modules/sass-loader/lib/loader.js??ref--3-rules-4!./src/components/Icon/Icon.scss
// module id = 1168
// module chunks = 0 1 2 3 4 5 6 7